














import {Component, Vue} from 'vue-property-decorator';

@Component({
    components: {},
})
export default class HeroExplainer extends Vue {
    public explainerBlocks = [
        {
            class: 'explainer-white',
            icon: 'fas fa-map-marker-alt',
            header: 'Anyplace you like',
            body: 'Please select where you would like your SoPlush Beauty Pro to complete your look.<br/>(Hotel, Home, Venue, Studio etc)',
            dark: false,
        },
        {
            class: 'explainer-white',
            icon: 'fas fa-calendar',
            header: 'Available at Your Schedule',
            body: 'Let us know the date and time you would like your Pro to arrive.',
            dark: false,
        },
        {
            class: 'explainer-white',
            icon: 'fas fa-cut',
            header: 'Hair, Makeup or Both?',
            body: 'Select your preferred beauty services.',
            dark: false,
        },
        {
            class: 'explainer-white',
            icon: 'fas fa-users',
            header: 'Choose Your Beauty Pro',
            body: 'We will match you with the perfect SoPlush Pro, or you may select directly from the gallery.',
            dark: false,
        },
    ];
    public get iconSize() {
        if (this.isXS(null)) { return 40; }
        if (this.isSM(null)) { return 48; }
        return 60;
    }
}
